module.exports = __webpack_public_path__ + "static/assets/49784ebf0b4b7a5c5b92e22a6c9d0734.png";